import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../Store'
import { boreholeLegendStyle } from './BoreholeLegend.style'
import { BoreholeLegendLayerObject } from '../../../dataSources/geo/BoreholeLegend'

/**
 * BoreholeLegendProps contains properties for the component.
 */
export interface BoreholeLegendProps { // eslint-disable-line @typescript-eslint/no-empty-interface
}

/**
 * BoreholeLegend displays legend for boreholes.
 * @param props Properties for component.
 * @returns JSX component.
 */
export const BoreholeLegend: FC<BoreholeLegendProps> = (props: BoreholeLegendProps) => {
  const classes = boreholeLegendStyle()
  const legend = useSelector((state: RootState) => state.boreholeInfo.legend)

  return (
    <div className={classes.root}>
      {legend?.Layers.map((layer: BoreholeLegendLayerObject, index: number) =>
        <div className={classes.layer} key={index}>
          <div className={classes.color} style={{ backgroundColor: layer.Color }} />
          <div className={classes.description}>
            {layer.Description}
          </div>
        </div>
      )}
    </div>
  )
}
